// noinspection JSUnusedGlobalSymbols

import type Legend from 'ol-ext/legend/Legend'

export class IntentionMapService {
    public vectorStyles: any
    public legend: Legend
    public legend2: Legend

    constructor(private map: Map) {
        this.vectorStyles = {}
    }

    setLegend(legend: Legend) {
        this.legend = legend
    }
}
